import {Injectable} from "@angular/core";

/**
 * Service for accessing the browser's window and local storage.
 * In environments where these are not available (e.g., Server Side Rendering),
 * methods return null to prevent errors when accessing these browser-specific APIs.
 */
@Injectable()
export abstract class WindowService {

    public abstract getWindow(): Window | null;

    public abstract getLocalStorage(): Storage | null
}
